@if (!currentSmartUserInterfaceMap) {
  <mat-form-field appearance="outline">
    <mat-label>{{field.Name}}</mat-label>
    <input matInput [placeholder]="field.Name" type="number" [formControl]="normalControl">
    <mat-icon matSuffix>looks_one</mat-icon>
    @if (field.Deprecation) {
      <mat-hint class="d-flex align-items-stretch">
        <mat-icon class="warning mr-1">warning</mat-icon>
        <span [matTooltip]="field.Deprecation">This field is deprecated, hover for more info</span>
      </mat-hint>
    }
    @if (field.Description && !field.Deprecation) {
      <mat-hint class="d-flex align-items-stretch">
        <mat-icon class="mr-1">info</mat-icon>
        <span [matTooltip]="field.Description">Hover for field description</span>
      </mat-hint>
    }
  </mat-form-field>
}

@if (currentSmartUserInterfaceMap) {
  <mat-form-field class="smart-field">
    <input matInput [placeholder]="field.Name" [matAutocomplete]="auto" [formControl]="normalControl">
    <div matSuffix>
      <mat-icon>assistant</mat-icon>
      @if (field.Deprecation) {
        <mat-icon class="warning" [matTooltip]="field.Deprecation">warning</mat-icon>
      }
      @if (field.Description) {
        <mat-icon [matTooltip]="field.Description">info</mat-icon>
      }
    </div>
    <mat-autocomplete #auto="matAutocomplete">
      @for (result of searchResults; track result) {
        <mat-option [value]="result.id">
          @if (result.img) {
            <div class="img-container">
              <img [src]="result.img" eva-image>
            </div>
          }
          {{ result.label }}
        </mat-option>
      }
    </mat-autocomplete>
    @if (!currentSmartUserInterfaceMap.shouldBeLoggedIn || (currentSmartUserInterfaceMap.shouldBeLoggedIn && !(isAnonymousUser$ | async))) {
      <mat-hint>
        {{ currentSmartUserInterfaceMap.hint }}
      </mat-hint>
    }
  </mat-form-field>
}
